const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const formatBuildDate = instrument =>
  instrument ? `${months[instrument.buildMonth - 1]} ${instrument.buildYear}` : '';

export default formatBuildDate;
